import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import routeFor from '../../../../Routes/routeFor';

import MenuItem from '../../MenuItem';

import { account } from '../../../../../../utils/propTypes';

function UserNavigation({ currentUser, t }) {
  return (
    <Fragment>
      {currentUser.availableMenus.slice(1).map(menu => (
        <MenuItem
          key={menu}
          exact={menu === 'home'}
          to={routeFor(menu)}
          label={t(`menu.${menu}`)}
        />
      ))}
    </Fragment>
  );
}

UserNavigation.propTypes = {
  currentUser: account.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(UserNavigation);



// WEBPACK FOOTER //
// ./src/app/components/NavigationBar/components/NavigationMenu/menus/UserNavigation.js